import { render, staticRenderFns } from "./file-loader.vue?vue&type=template&id=f55c34b8&scoped=true&"
import script from "./file-loader.vue?vue&type=script&lang=js&"
export * from "./file-loader.vue?vue&type=script&lang=js&"
import style0 from "./file-loader.vue?vue&type=style&index=0&id=f55c34b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55c34b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f55c34b8')) {
      api.createRecord('f55c34b8', component.options)
    } else {
      api.reload('f55c34b8', component.options)
    }
    module.hot.accept("./file-loader.vue?vue&type=template&id=f55c34b8&scoped=true&", function () {
      api.rerender('f55c34b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file-loader.vue"
export default component.exports